import React, { FC } from 'react';
import { classes, stylesheet } from 'typestyle';
import { AirtableAttachment, DocType } from '../../../types';
import { CloseIcon, DownloadIcon } from '@traceair/webapp-icons';
import { Button, ButtonIcon, typeCompact14Medium, White } from '@traceair/tds';
import { trackAction } from '../../../libs/analytics/ActionTracking';
import { useAppStore } from '../../../store/appStore';
import downloadAll from './DocCards/utils/download-all';

type ViewDocPopupProps = {
  docType: DocType;
  attachments: AirtableAttachment[];
};

const ViewDocPopup: FC<ViewDocPopupProps> = ({ docType, attachments }) => {
  const hideWindow = useAppStore((state) => state.hideWindow);

  function handleCloseClick() {
    trackAction('Close all document attachments window click', null);
    hideWindow();
  }

  function handleDownloadClick() {
    trackAction('Download all document files button click', null);

    downloadAll(attachments);
  }

  return (
    <div className={css.root}>
      <div className={css.buttonsContainer}>
        <Button icon={<DownloadIcon />} type="white" style="primary" text="Download" onClick={handleDownloadClick} />
        <ButtonIcon icon={<CloseIcon />} type="white" style="primary" onClick={handleCloseClick} />
      </div>
      <div className={classes(css.header, typeCompact14Medium)}>{docType}</div>
      <div className={css.previewContainer}>
        {attachments.map((attachment) =>
          attachment.thumbnails?.large ? (
            <img key={attachment.id} src={attachment.thumbnails?.large.url} alt="preview" style={{ width: '100%' }} />
          ) : null,
        )}
      </div>
    </div>
  );
};

const css = stylesheet({
  root: {
    width: 720,
    maxHeight: 'calc(100vh - 120px)',
    borderRadius: 16,
    boxShadow: '0px 3px 20px 0px rgba(0, 0, 0, 0.20), 0px 6px 40px 0px rgba(0, 0, 0, 0.40)',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: White,
  },
  header: {
    height: 48,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonsContainer: {
    position: 'absolute',
    top: 4,
    right: 4,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  downloadButton: {
    padding: '0 8px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    cursor: 'pointer',
  },
  previewContainer: {
    maxHeight: '100%',
    overflowY: 'auto',
  },
});

export default ViewDocPopup;
